import React from 'react';
import { Box, Button } from '@mantine/core';
import { IconArrowBackUp, IconCompass } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import EmptyState from '@/components/ui/Empty.State';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box
            style={{
                minHeight: '100dvh',
                display: 'grid',
                placeItems: 'center',
                padding: 'max(1rem, env(safe-area-inset-top, 0px)) max(1rem, env(safe-area-inset-right, 0px)) max(1rem, env(safe-area-inset-bottom, 0px)) max(1rem, env(safe-area-inset-left, 0px))',
                boxSizing: 'border-box',
            }}
        >
            <EmptyState
                icon={IconCompass}
                title="Pagina non trovata"
                body="Il percorso non corrisponde a nessuna voce di beDashboard."
                action={<Button variant="default" leftSection={<IconArrowBackUp size={16} />} onClick={() => navigate('/overview')}>Vai alla panoramica</Button>}
            />
        </Box>
    );
};

export default NotFound;
